import { Info } from "lucide-react";
import { Panel, Stat, formatMonth, useOrgStyles } from "../../components/org/orgUi";
import { useOrgPortal } from "./orgPortalContext";

export default function OrgOverview() {
    const { org, isOrgAdmin, goTo } = useOrgPortal();
    const s = useOrgStyles();
    const now = new Date();
    const periodLabel = formatMonth(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`);
    return (
        <div className="space-y-6">
            {org.OrgType === "education" && (
                <div className={`flex items-start gap-3 rounded-2xl border p-4 text-sm ${s.subPanel}`}>
                    <Info size={18} className={`mt-0.5 flex-shrink-0 ${s.muted}`} />
                    <p className={s.body}>
                        Education organizations can run programs and invite students for free. Viewing student details
                        (resume reviews, quarterly results, program progress) is available on the Enterprise plan.
                        Contact Build My Biz Brand to upgrade.
                    </p>
                </div>
            )}
            <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
                <Stat label="Students" value={org.StudentCount} hint="On your roster" />
                <Stat label="Programs" value={`${org.ProgramCount} / ${org.ProgramLimit}`}
                      tone={org.ProgramCount >= org.ProgramLimit ? "warn" : "default"} hint="Active / allowed" />
                <Stat label="Coach licenses" value={`${org.CoachLicensesUsed} / ${org.CoachLicenseLimit}`}
                      hint={periodLabel} tone={org.CoachLicensesUsed >= org.CoachLicenseLimit ? "warn" : "default"} />
                <Stat label="Student licenses" value={`${org.StudentLicensesUsed} / ${org.StudentLicenseLimit}`}
                      hint={periodLabel} tone={org.StudentLicenseLimit > 0 && org.StudentLicensesUsed >= org.StudentLicenseLimit ? "warn" : "default"} />
            </div>
            <Panel title="Get started">
                <ol className={`space-y-3 text-sm ${s.body}`}>
                    <li><strong className={s.text}>1. Create a program.</strong> Each program gets an invitation code students enter under My Coaching → Programs.{" "}
                        <button type="button" className={s.btnLink} onClick={() => goTo("programs")}>Programs</button></li>
                    <li><strong className={s.text}>2. Add students.</strong> Share the code, or import a list of emails.{" "}
                        <button type="button" className={s.btnLink} onClick={() => goTo("students")}>Students</button></li>
                    {isOrgAdmin && (
                        <li><strong className={s.text}>3. Assign licenses.</strong> Licenses run from the 1st to the end of each month.
                            A license you remove can't go to someone else until next month.{" "}
                            <button type="button" className={s.btnLink} onClick={() => goTo("licenses")}>Licenses</button></li>
                    )}
                    <li><strong className={s.text}>{isOrgAdmin ? "4" : "3"}. Review progress.</strong> Students choose what to share with your coaches
                        (resume, quarterly results, program progress).</li>
                </ol>
                {org.SponsoredStudentTierName && (
                    <p className={`mt-4 text-xs ${s.muted}`}>
                        Licensed students get the {org.SponsoredStudentTierName} plan while their license is active.
                    </p>
                )}
            </Panel>
        </div>
    );
}
